<div class="card">
  <div class="card-body">
    <h5>{{ "QUẢN LÝ ZNS THÔNG BÁO GIA HẠN TỰ ĐỘNG" | translate }}</h5>

    <!-- FILTER -->
    <div class="row">
      <!-- Chart 1 -->
      <div class="col-12 col-lg-4" *ngIf="role === 'admin'">
        <div class="card mb-4">
          <div class="card-header">
            <strong>Thống kê trạng thái gửi ZNS</strong>
          </div>

          <div class="card-body d-flex justify-content-center">
            <apx-chart
              *ngIf="chartOptions?.series"
              [series]="chartOptions.series"
              [chart]="chartOptions.chart"
              [labels]="chartOptions.labels"
              [colors]="chartOptions.colors"
              [legend]="chartOptions.legend"
              [dataLabels]="chartOptions.dataLabels"
              [plotOptions]="chartOptions.plotOptions"
            >
            </apx-chart>
          </div>
        </div>
      </div>

      <!-- Chart 2 -->
      <div class="col-12 col-lg-4" *ngIf="role === 'admin'">
        <div class="card mb-4">
          <div class="card-header">
            <strong>Thống kê phản hồi của khách hàng</strong>
          </div>

          <div class="card-body d-flex justify-content-center">
            <apx-chart
              *ngIf="chartOptions2?.series"
              [series]="chartOptions2.series"
              [chart]="chartOptions2.chart"
              [labels]="chartOptions2.labels"
              [colors]="chartOptions2.colors"
              [legend]="chartOptions2.legend"
              [dataLabels]="chartOptions2.dataLabels"
              [plotOptions]="chartOptions2.plotOptions"
            >
            </apx-chart>
          </div>
        </div>
      </div>

      <!-- Filter Column -->
      <div class="col-12 col-lg">
        <div class="form-group col-md">
          <label>Chọn trạng thái gửi ZNS</label>
          <ng-select [(ngModel)]="filter.send_status" [clearable]="true">
            <ng-option *ngFor="let item of listStatusSend" [value]="item.value">
              {{ item.label }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group col-md">
          <label>Chọn phản hồi của khách hàng</label>
          <ng-select
            [(ngModel)]="filter.status"
            [clearable]="true"
          >
          <ng-option *ngFor="let item of listStatus" [value]="item.value">
            {{ item.label }}
          </ng-option>
          </ng-select>
        </div>

        <div class="form-group col-md">
          <label>Số tài khoản</label>
          <input
            class="form-control"
            [(ngModel)]="filter.terminal_bank_acc"
            placeholder="Nhập số tài khoản"
          />
        </div>

        <div class="form-group col-md">
          <label>Mã thiết bị</label>
          <input
            class="form-control"
            [(ngModel)]="filter.serial_number"
            placeholder="Nhập Mã thiết bị"
          />
        </div>

        <div class="form-group col-md">
          <label>Số điện thoại</label>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="filter.phone"
            placeholder="Nhập số điện thoại"
          />
        </div>

        <div class="form-group col-md text-center">
          <button class="btn btn-primary" (click)="submitFilter()">
            Tìm kiếm
          </button>
          <button
            class="btn btn-dark ml-2"
            *ngIf="searching"
            (click)="clearFilter()"
          >
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- TABLE -->
    <div class="table-responsive mt-3">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap zns-table"
      >
        <colgroup>
          <col style="width: 40px" />
          <col style="width: 120px" />
          <col style="width: 150px" />
          <col style="width: 100px" />
          <col style="width: 80px" />
          <col style="width: 120px" />
          <col style="width: 80px" />
          <col style="width: 120px" />
          <col style="width: 60px" />
          <col style="width: 40px" />
        </colgroup>
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th class="first-column">{{ "Thông tin khách hàng" | translate }}</th>
            <th>{{ "Thông tin tài khoản" | translate }}</th>
            <th>{{ "Mã thiết bị" | translate }}</th>
            <th>{{ "Phản hồi của KH" | translate }}</th>
            <th>{{ "Ghi chú" | translate }}</th>
            <th>{{ "Trạng thái gửi ZNS" | translate }}</th>
            <th>{{ "Lỗi gửi ZNS" | translate }}</th>
            <th>{{ "Loại thiết bị" | translate }}</th>
            <th *ngIf="role !== 'operation'">
              {{ "Quản lý" | translate }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column">
              {{ pageSize * (pageIndex - 1) + i + 1 }}
            </td>
            <td class="table-column">
              <div>{{ data.phone }}</div>
              <div>{{ data.full_name }}</div>
            </td>
            <td class="table-column">
              <div>{{ data.terminal_bank_acc }}</div>
              <div>{{ data.terminal_bank_acc_name }}</div>
            </td>
            <td class="table-column">{{ data.serial_number }}</td>
            <td class="table-column">
              <span
                *ngIf="getResponseInfo(data.status); else noResponse"
                class="badge"
                [ngStyle]="{
                  'background-color': getResponseInfo(data.status).color,
                  color: '#fff'
                }"
              >
                {{ getResponseInfo(data.status).label }}
              </span>
              <ng-template #noResponse></ng-template>
            </td>
            <td class="table-column">{{ data.note || "" }}</td>
            <td class="table-column">
              <div>
                <span
                  class="badge"
                  [ngStyle]="{
                    'background-color': getSendStatusInfo(data.send_status).color,
                    color: '#fff'
                  }"
                >
                  {{ getSendStatusInfo(data.send_status).label }}
                </span>
              </div>
              <div>
                {{
                  data.last_sent_at
                    ? (data.last_sent_at | date : "dd/MM/yyyy HH:mm")
                    : "-"
                }}
              </div>
            </td>
            <td class="table-column">{{ data.last_error }}</td>
            <td class="table-column">{{ data.device_type_name || "-" }}</td>

            <td *ngIf="role !== 'operation'" class="table-column">
              <a
                class="font-size-18 text-primary"
                ngbTooltip="Cập nhật thông tin"
                (click)="showUpdateNoteModal(data)"
                style="cursor: pointer"
              >
                <i class="ri-edit-line"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- PAGINATION -->
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }}
          {{
            pageSize * pageIndex > totalCount
              ? totalCount
              : pageSize * pageIndex
          }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
